import axios from 'axios'

export default axios.create({
  baseURL: 'https://api31.test-oak.pl',
});